/* unplugin-vue-components disabled */import script from "./BroadcastItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BroadcastItem.vue?vue&type=script&setup=true&lang=ts"

import "./BroadcastItem.vue?vue&type=style&index=0&id=4fd0f421&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd0f421"]])

export default __exports__